<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useNotificationsStore } from '@/store/notifications'

const router = useRouter()
const notifStore = useNotificationsStore()

// marquee 用最新 3 条未读
const items = computed(() => notifStore.recentUnread.slice(0, 3))
const text = computed(() => items.value.map((n) => n.title).join('  ·  '))
const show = computed(() => items.value.length > 0)

// 重复偶数次以让 CSS animation 看上去无缝（拼接前后内容）
const longText = computed(() => (text.value ? text.value + '  ·  ' : ''))

const clickAnchor = ref<HTMLElement | null>(null)

watch(show, (v) => {
  if (v && items.value.length > 0) {
    // 自动滚动到顶部
    setTimeout(() => clickAnchor.value?.scrollIntoView({ behavior: 'smooth' }), 0)
  }
})

function handleClick() {
  const first = items.value[0]
  if (!first) return
  if (first.link && first.link.startsWith('/')) {
    router.push(first.link).catch(() => router.push('/orders'))
  } else {
    router.push('/orders')
  }
  notifStore.markRead(first.id)
}
</script>

<template>
  <div
    v-if="show"
    ref="clickAnchor"
    class="bg-amber-50 border-b border-amber-200 cursor-pointer overflow-hidden"
    @click="handleClick"
  >
    <div class="max-w-3xl mx-auto px-4 py-1.5 flex items-center gap-2 text-amber-900">
      <span class="text-sm shrink-0">📣</span>
      <div class="flex-1 overflow-hidden relative h-5">
        <div class="marquee-track whitespace-nowrap text-sm leading-5">
          <span class="px-4">{{ longText }}</span>
          <span class="px-4">{{ longText }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.marquee-track {
  display: inline-block;
  animation: marquee 28s linear infinite;
  will-change: transform;
}
.marquee-track:hover {
  animation-play-state: paused;
}
@keyframes marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}
</style>
